import { StorefrontValuesModule } from "@modules/storefront_values/StorefrontValuesModule";
import { inject, singleton } from "tsyringe";

import { ModuleInterface } from "@interfaces/ModuleInterface";

import GrowaveStorefrontValuesService from "./services/GrowaveStorefrontValuesService";

interface GrowaveStorefrontValuesModuleExports {
    growaveStorefrontValuesService: GrowaveStorefrontValuesService;
}

@singleton()
export class GrowaveStorefrontValuesModule
    implements ModuleInterface<GrowaveStorefrontValuesModuleExports>
{
    exports: GrowaveStorefrontValuesModuleExports;

    constructor(
        @inject(StorefrontValuesModule)
        private readonly storefrontValuesModule: StorefrontValuesModule
    ) {
        this.exports = {
            growaveStorefrontValuesService: new GrowaveStorefrontValuesService(
                this.storefrontValuesModule
            ),
        };
    }

    public registerProviders() {
        return {};
    }
}

export default GrowaveStorefrontValuesModule;
